import axios from 'axios'

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // 设置基础URL
  timeout: 5000 // 请求超时时间
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 可以在这里添加token等认证信息
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    // 可以统一处理响应数据
    return response.data
  },
  error => {
    // 统一处理错误
    return Promise.reject(error)
  }
)

export default request 